(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["account-community"] && !window.DesignMode) return;
  try {
    
var loaded = false;
$('body').on('DOMNodeInserted','.lion-loyalty-panel-rule-item[data-rule-id="115732"]', function() {
	if (!loaded) {
		$('.lion-loyalty-panel-page-earn__rules-list').append('<a href="https://www.strava.com/clubs/Days-brewing" class="lion-loyalty-panel-rule-item lion-loyalty-panel-rule-item--actionable"><div class="lion-loyalty-panel-rule-item__content"><div class="lion-loyalty-panel-rule-item__icon lion-icon lion-icon__rule lion-icon__rule--custom"></div><div class="lion-loyalty-panel-rule-item__title">Join Strava</div></div></a>');
	}
	loaded = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["account-navigation"] && !window.DesignMode) return;
  try {
    
const link = $(".accountportal__navigation a[href='" + location.pathname + location.search + "']");
link.addClass('accountportal__menulink--current');

$('#customer_logout_link').on('click', function(e) {
    e.preventDefault();
    const logoutlink = $(this).attr('href');
    var itemsToClear = {};
    $.getJSON('/cart.js', function(cart) {
   		// now have access to Shopify cart object
      cart.items.forEach(function(item) {
    // do something with `item`
        if(item.properties['Exclusive'] != undefined) {
//           console.log('remove this item');
          
          itemsToClear[item.variant_id] = 0;
        }
	  });
      console.log(itemsToClear);
      if (!$.isEmptyObject(itemsToClear)) { 
//         console.log('clearing items');
        $.ajax({
      		type: "POST",
      		url: '/cart/update.js',
          	data: { updates: itemsToClear },
          	dataType: 'json',
      		success: function() {
//               console.log('successfully updated cart, redirecting user...');
            	window.location.href = logoutlink;
      		}
		});
      } else {
        window.location.href = logoutlink;
      }
	});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
	function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
function eraseCookie(name) {
    setCookie(name,"",-1);
}
	var hidePopup = false;
	if ($('.pop--newsletter__disable').length > 0) {
		hidePopup = true;
	}

  	const popupCookie = 'popupNewsDismissed';
	const popupDismissedPrev = getCookie(popupCookie);
    const $popupNewsltr = $('.pop--newsletter');
                                 
    function checkPopup() {
		if (popupDismissedPrev || hidePopup) {
        	$popupNewsltr.remove();
	    }
    	else {
    	    setTimeout(function() {
        	    $popupNewsltr.addClass('activated');
	        }, 3000);
    	}
	}
  
  checkPopup();

  $('.pop__close').on('click', function() {
      setCookie(popupCookie, true, 60);
      $popupNewsltr.removeClass('activated');
  });
  $('.pop--newsletter form').on('submit', function(e) {
      setCookie(popupCookie, true, 60);
  });

  } catch(e) { console.error(e); }
})();
      })();
